import React, { useState } from "react";
import Nav from "../../components/nav/Nav";
import Footer from "../../components/footer/Footer";
import "./authPages.css";
import CustomInput from "../../components/customInput/CustomInput";
import { ReactComponent as EyeCross } from "../../assets/eyeCross.svg";
import { ReactComponent as Eye } from "../../assets/fi-rr-eye.svg";
import CustomButton from "../../components/CustomButton";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const RegisterPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const [backdropopen, setbackdropopen] = useState(false);

  const isFormValid = email && password && confirmPassword;

  const validatePassword = (password) => {
    const minLength = /.{6,}/;

    if (!minLength.test(password)) {
      return "Password must be at least 6 characters long.";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    setbackdropopen(true);

    try {
      const response = await axios.post(`${base_url.api1}/users/user`, {
        email,
        password,
      });
      console.log(response);
      toast.success("User Registered Successfully");

      navigate("/login");
      setbackdropopen(false);
    } catch (err) {
      setError(err.response?.data?.message);
      toast.error(err.response?.data?.message);
      // console.error(err?.message);
      // console.error(err.response.status);
      setbackdropopen(false);
    }
  };

  return (
    <div>
      <Nav />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="register">
        <ToastContainer />
        <div className="register-container">
          <div>
            <h3 className="login-header">Register</h3>
            <p className="sub-login-header">
              This will help you keep track of your claims
            </p>
          </div>

          <form className="input-container" onSubmit={(e) => handleSubmit(e)}>
            <div style={{ marginTop: "20px" }}>
              <label className="login-label">
                Email address <span style={{ color: "#D04244" }}>*</span>
              </label>
              <div
                style={{ border: error ? "1px solid #D04244" : "none" }}
                className="input-box"
              >
                <input
                  className="save-progress-input"
                  placeholder={"Enter your email"}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div style={{ marginTop: "20px" }}>
              <label className="login-label">
                Password <span style={{ color: "#D04244" }}>*</span>
              </label>
              <div
                style={{ border: error ? "1px solid #D04244" : "none" }}
                className="input-box"
              >
                <input
                  className="save-progress-input"
                  placeholder={"Enter your password"}
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <EyeCross /> : <Eye />}
                </button>
              </div>
            </div>

            <div style={{ marginTop: "20px" }}>
              <label className="login-label">
                Confirm password <span style={{ color: "#D04244" }}>*</span>
              </label>
              <div
                style={{ border: error ? "1px solid #D04244" : "none" }}
                className="input-box"
              >
                <input
                  className="save-progress-input"
                  placeholder={"Confirm your password"}
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showConfirmPassword ? <EyeCross /> : <Eye />}
                </button>
              </div>
            </div>

            <div style={{ marginTop: "5px" }}>
              {error ? (
                <p style={{ textAlign: "center", color: "#D04244" }}>{error}</p>
              ) : (
                <p></p>
              )}
            </div>

            <div style={{ marginTop: "15px" }}>
              <div className="checkbox-wrapper">
                <input
                  className="checkbox-input"
                  style={{ marginTop: "5px" }}
                  type="checkbox"
                  required
                />
                <p className="checkbox-label">
                  I agree to the Terms and Conditions, Price list and the
                  Privacy Policy
                </p>
              </div>
              <div className="checkbox-wrapper">
                <input
                  className="checkbox-input"
                  style={{ marginTop: "5px" }}
                  type="checkbox"
                  required
                />
                <p className="checkbox-label">
                  I agree to receive news about air passenger rights, new
                  compensation possibilities, easier claim processing ways,
                  along with useful tips and exclusive offers from Fly n’ Claim
                  and their partners.
                </p>
              </div>
            </div>

            <CustomButton
              style={{
                width: "100%",
                marginTop: "20px",
                backgroundColor: !isFormValid ? "#ccc" : "#314064",
                cursor: !isFormValid ? "not-allowed" : "pointer",
              }}
              btnText="REGISTER"
              type="submit"
              disabled={!isFormValid}
            />

            <p
              onClick={() => navigate("/login")}
              style={{
                textAlign: "center",
                marginTop: "20px",
                cursor: "pointer",
              }}
            >
              Already have an account?{" "}
              <span style={{ color: "#314064", fontWeight: "700" }}>Login</span>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RegisterPage;
